import LogMessage from './utilities/LogMessage';

export default class ErrorHandler {

    static LOG_TO_SERVER: boolean = true;

    /**
     * Is called by eventListeners for "error" and "unhandeldRejection".
     * Returns if error was handled or not
     * @param error
     */
    static async handleError(error): Promise<boolean> {
        if (ErrorHandler.LOG_TO_SERVER) {
            if (error instanceof Response) {
                if (await this.redirectIfNeeded(error)) {
                    return;
                }
            }

            try {
                await this.logError(error);
                return true;
            } catch (e) {
                return false;
            }
        }
        return false;
    }

    private static redirectIfNeeded(errorResponse: Response): Promise<boolean> {
        if (errorResponse.status === 401 || errorResponse.status === 403) {
            return errorResponse.text().then(function redirect(url) {
                if (url) {
                    window.location.replace(url + '&redirectUrl=' + encodeURIComponent(window.location.pathname));
                } else {
                    const contextBase = process.env.VUE_APP_CONTEXT_BASE;
                    const prefix = contextBase.startsWith('/') ? '' : '/';
                    window.location.replace(prefix + contextBase + '/accessDenied');
                }
                return true;
            });
        }
        return Promise.resolve(false);
    }

    /**
     * Used to globally log errors.
     * Returns if the error was logged (to prevent double logging in some occasions)
     * @param error
     */
    private static async logError(error): Promise<unknown> {
        let message;

        if (error instanceof Response) {
            message = await error.text();
        } else {
            message = error.stack;
        }

        return new LogMessage()
            .setErrorMessage(message)
            .send();
    }

}
